/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */
export var TABLE_BODY = "pt-table-body";
export var TABLE_BODY_SCROLL_CLIENT = "pt-table-body-scroll-client";
export var TABLE_BODY_VIRTUAL_CLIENT = "pt-table-body-virtual-client";
export var TABLE_BOTTOM_CONTAINER = "pt-table-bottom-container";
export var TABLE_CELL = "pt-table-cell";
export var TABLE_CELL_CLIENT = "pt-table-cell-client";
export var TABLE_CELL_GHOST = "pt-table-cell-ghost";
export var TABLE_CELL_INTERACTIVE = "pt-table-cell-interactive";
export var TABLE_CELL_LEDGER_EVEN = "pt-table-cell-ledger-even";
export var TABLE_CELL_LEDGER_ODD = "pt-table-cell-ledger-odd";
export var TABLE_COLUMN_HEADER_TR = "pt-table-column-header-tr";
export var TABLE_COLUMN_HEADERS = "pt-table-column-headers";
export var TABLE_COLUMN_HEADER_CELL = "pt-table-column-header-cell";
export var TABLE_COLUMN_NAME = "pt-table-column-name";
export var TABLE_COLUMN_NAME_TEXT = "pt-table-column-name-text";
export var TABLE_CONTAINER = "pt-table-container";
export var TABLE_DRAGGING = "pt-table-dragging";
export var TABLE_EDITABLE_NAME = "pt-table-editable-name";
export var TABLE_EDITABLE_TEXT = "pt-table-editable-text";
export var TABLE_FOCUS_REGION = "pt-table-focus-region";
export var TABLE_HAS_INTERACTION_BAR = "pt-table-has-interaction-bar";
export var TABLE_HAS_REORDER_HANDLE = "pt-table-has-reorder-handle";
export var TABLE_HEADER = "pt-table-header";
export var TABLE_HEADER_ACTIVE = "pt-table-header-active";
export var TABLE_HEADER_CONTENT = "pt-table-header-content";
export var TABLE_HEADER_REORDERABLE = "pt-table-header-reorderable";
export var TABLE_HEADER_SELECTED = "pt-table-header-selected";
export var TABLE_HORIZONTAL_CELL_DIVIDER = "pt-table-horizontal-cell-divider";
export var TABLE_HORIZONTAL_GUIDE = "pt-table-horizontal-guide";
export var TABLE_INTERACTION_BAR = "pt-table-interaction-bar";
export var TABLE_LAST_IN_COLUMN = "pt-table-last-in-column";
export var TABLE_LAST_IN_ROW = "pt-table-last-in-row";
export var TABLE_MENU = "pt-table-menu";
export var TABLE_NO_HORIZONTAL_SCROLL = "pt-table-no-horizontal-scroll";
export var TABLE_NO_LAYOUT = "pt-table-no-layout";
export var TABLE_NO_ROWS = "pt-table-no-rows";
export var TABLE_NO_VERTICAL_SCROLL = "pt-table-no-vertical-scroll";
export var TABLE_NO_WRAP_TEXT = "pt-table-no-wrap-text";
export var TABLE_NULL = "pt-table-null";
export var TABLE_OVERLAY = "pt-table-overlay";
export var TABLE_OVERLAY_LAYER = "pt-table-overlay-layer";
export var TABLE_OVERLAY_REORDERING_CURSOR = "pt-table-reordering-cursor-overlay";
export var TABLE_POPOVER_WHITESPACE_NORMAL = "pt-table-popover-whitespace-normal";
export var TABLE_POPOVER_WHITESPACE_PRE = "pt-table-popover-whitespace-pre";
export var TABLE_QUADRANT = "pt-table-quadrant";
export var TABLE_QUADRANT_BODY_CONTAINER = "pt-table-quadrant-body-container";
export var TABLE_QUADRANT_LEFT = "pt-table-quadrant-left";
export var TABLE_QUADRANT_MAIN = "pt-table-quadrant-main";
export var TABLE_QUADRANT_SCROLL_CONTAINER = "pt-table-quadrant-scroll-container";
export var TABLE_QUADRANT_STACK = "pt-table-quadrant-stack";
export var TABLE_QUADRANT_TOP = "pt-table-quadrant-top";
export var TABLE_QUADRANT_TOP_LEFT = "pt-table-quadrant-top-left";
export var TABLE_REGION = "pt-table-region";
export var TABLE_REORDER_HANDLE = "pt-table-reorder-handle";
export var TABLE_REORDER_HANDLE_TARGET = "pt-table-reorder-handle-target";
export var TABLE_REORDERING = "pt-table-reordering";
export var TABLE_RESIZE_GUIDES = "pt-table-resize-guides";
export var TABLE_RESIZE_HANDLE = "pt-table-resize-handle";
export var TABLE_RESIZE_HANDLE_TARGET = "pt-table-resize-handle-target";
export var TABLE_RESIZE_HORIZONTAL = "pt-table-resize-horizontal";
export var TABLE_RESIZE_SENSOR = "pt-table-resize-sensor";
export var TABLE_RESIZE_SENSOR_EXPAND = "pt-table-resize-sensor-expand";
export var TABLE_RESIZE_SENSOR_SHRINK = "pt-table-resize-sensor-shrink";
export var TABLE_RESIZE_VERTICAL = "pt-table-resize-vertical";
export var TABLE_ROUNDED_LAYOUT = "pt-table-rounded-layout";
export var TABLE_ROW_HEADERS = "pt-table-row-headers";
export var TABLE_ROW_HEADERS_CELLS_CONTAINER = "pt-table-row-headers-cells-container";
export var TABLE_ROW_NAME = "pt-table-row-name";
export var TABLE_ROW_NAME_TEXT = "pt-table-row-name-text";
export var TABLE_SELECTION_ENABLED = "pt-table-selection-enabled";
export var TABLE_SELECTION_REGION = "pt-table-selection-region";
export var TABLE_TH_MENU = "pt-table-th-menu";
export var TABLE_TH_MENU_CONTAINER = "pt-table-th-menu-container";
export var TABLE_TH_MENU_CONTAINER_BACKGROUND = "pt-table-th-menu-container-background";
export var TABLE_TH_MENU_OPEN = "pt-table-th-menu-open";
export var TABLE_THEAD = "pt-table-thead";
export var TABLE_TOP_CONTAINER = "pt-table-top-container";
export var TABLE_TRUNCATED_CELL = "pt-table-truncated-cell";
export var TABLE_TRUNCATED_FORMAT = "pt-table-truncated-format";
export var TABLE_TRUNCATED_FORMAT_TEXT = "pt-table-truncated-format-text";
export var TABLE_TRUNCATED_POPOVER = "pt-table-truncated-popover";
export var TABLE_TRUNCATED_POPOVER_TARGET = "pt-table-truncated-popover-target";
export var TABLE_TRUNCATED_TEXT = "pt-table-truncated-text";
export var TABLE_TRUNCATED_VALUE = "pt-table-truncated-value";
export var TABLE_VERTICAL_GUIDE = "pt-table-vertical-guide";
/** Common code for row and column index class generator functions, since they're essentially the same. */
function dimensionIndexClass(classPrefix, index) {
    if (index == null) {
        return undefined;
    }
    if (typeof index === "number") {
        return "" + classPrefix + index;
    }
    return index.indexOf(classPrefix) === 0 ? index : "" + classPrefix + index;
}
/** Return CSS class for table colummn index, whether or not 'pt-table-col-' prefix is included. */
export function columnIndexClass(columnIndex) {
    return dimensionIndexClass("pt-table-col-", columnIndex);
}
/** Return CSS class for table row index, whether or not 'pt-table-row-' prefix is included. */
export function rowIndexClass(rowIndex) {
    return dimensionIndexClass("pt-table-row-", rowIndex);
}
/** Return CSS class for table colummn cell index, whether or not 'pt-table-cell-col-' prefix is included. */
export function columnCellIndexClass(columnIndex) {
    return dimensionIndexClass("pt-table-cell-col-", columnIndex);
}
/** Return CSS class for table row cell index, whether or not 'pt-table-cell-row-' prefix is included. */
export function rowCellIndexClass(rowIndex) {
    return dimensionIndexClass("pt-table-cell-row-", rowIndex);
}
